// firebaseConfig.ts
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAiJNQJDf7LRcC6htUzJ0UOdsoQeuPq98s",
  authDomain: "cpas-alert.firebaseapp.com",
  databaseURL: "https://cpas-alert-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "cpas-alert",
  storageBucket: "cpas-alert.appspot.com", // ✅ corrigé (.app → .appspot.com)
  messagingSenderId: "459957795415",
  appId: "1:459957795415:web:845630e478e5d2f67a8112",
  measurementId: "G-880L3KX4CB"
};

// 🔥 Initialisation de Firebase
const app = initializeApp(firebaseConfig);

// 📦 Export des services utilisés par l’application
export const db = getDatabase(app);
export const auth = getAuth(app);

export default app;
